import { MTableEditField } from '@material-table/core';
import Done from '@mui/icons-material/Done';
import Remove from '@mui/icons-material/Remove';
import React from 'react';
import { isYes } from 'utils/import/columns';

// title and field properties are used in material table,
// label and key are used in CSV export

export default user => {
  const columns = [
    {
      title: 'Código fornecedor',
      field: 'code',
      minWidth: 100,
      headerStyle: {
        textAlign: 'left'
      },
      cellStyle: {
        textAlign: 'left'
      }
    },
    {
      title: 'Nome',
      field: 'name',
      minWidth: 500,
      headerStyle: {
        textAlign: 'center'
      },
      cellStyle: {
        textAlign: 'left'
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>
    },
    {
      title: 'Activo',
      field: 'active',
      type: 'boolean',
      minWidth: 50,
      initialEditValue: 'false',
      headerStyle: {
        textAlign: 'center'
      },
      cellStyle: {
        textAlign: 'center'
      },
      lookup: {
        true: 'Sim',
        false: 'Não'
      },
      render: rowData =>
        <span style={{ fontWeight: isYes(rowData.active) ? 'bold' : null }}>
        {isYes(rowData.active) ? 'Sim' : 'Não' }
      </span>
    }
  ];

  const columnsAdmin = [
    {
      title: 'Identificador',
      field: 'id',
      editable: 'never',
      width: 100
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
